import React from 'react';
import TextModalHeading from "../UI/Typography/TextModalHeading";
import Button from "../UI/Button/Button";
import Modal from "../UI/Modal/Modal";
import {IModalProps} from "./types";
import {ModalButtonsWrap} from "./styles";
import useAppDispatch from "../../hooks/useDispatch";
import {setConfigDoors} from "../../store/configSlice";
import useAppSelector from "../../hooks/useSelector";
import TextRegularGrey from '../UI/Typography/TextRegularGrey';
import {setSelectedDoorId} from "../../store/appSlice";
import usePaginator from '../../hooks/usePaginator';

const ModalWrongDoorCount = ({ onClose }: IModalProps) => {
  const doors = useAppSelector((state) => state.config.doors);
  const totalDoors = useAppSelector((state) => state.config.totalDoors);
  const { onForward } = usePaginator();

  const dispatch = useAppDispatch();

  const onConfirm = () => {
    const newArray = [...doors];
    newArray.length = Number(totalDoors);
    dispatch(setConfigDoors(newArray));
    dispatch(setSelectedDoorId(newArray[0].id));
    onForward();
    onClose();
  };

  return (
    <Modal
      onClose={onClose}
    >
      <TextModalHeading
        sx={{
          marginBottom: '32px',
        }}
      >
        Türen abbauen?
      </TextModalHeading>
      <TextRegularGrey>
        Sie haben die Anzahl der Türen reduziert. Die {doors.length - Number(totalDoors)} Türen am Ende der Liste werden zusammen mit den Einstellungen gelöscht.
      </TextRegularGrey>
      <ModalButtonsWrap>
        <Button
          sx={{
            width: '122px',
          }}
          onClick={onClose}
          variant='second'
        >
          Abbrechen
        </Button>
        <Button
          sx={{
            width: '100%',
          }}
          onClick={onConfirm}
        >
          Löschen
        </Button>
      </ModalButtonsWrap>
    </Modal>
  );
};

export default ModalWrongDoorCount;
